import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import OpportunityCard from "@/components/OpportunityCard";
import { Lightbulb } from "lucide-react";

export default function Opportunities() {
  const [opps, setOpps] = useState(null);
  useEffect(() => {
    api.get("/opportunities").then(({ data }) => setOpps(data)).catch(() => setOpps([]));
  }, []);

  return (
    <div className="space-y-6 fade-up" data-testid="opportunities-page">
      <div>
        <h1 className="font-serif text-3xl font-bold text-navy">Marketing Opportunities</h1>
        <p className="text-muted-foreground mt-1">Rule-based recommendations from your inventory, campaign history and calendar. No AI, just smart timing.</p>
      </div>
      {opps === null ? (
        <div className="text-center py-20 text-muted-foreground">Loading opportunities...</div>
      ) : opps.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground bg-white rounded-2xl border border-border" data-testid="opportunities-empty">
          <Lightbulb className="w-10 h-10 mx-auto mb-3 opacity-40" />
          You are all caught up. New opportunities appear as inventory ages, prices change and events approach.
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="opportunities-list">
          {opps.map((o) => <OpportunityCard key={o.id} opp={o} />)}
        </div>
      )}
    </div>
  );
}
